import React from 'react';
import { configurable, sourceNotes } from '../../data/market/config';
import { screenshots } from '../../data/market/screenshots';

/** Solo vista del staff: valores por confirmar y diferencias entre fuentes. No contiene procedimientos internos. */
export function MarketPendingData() {
  return <section aria-labelledby="pend-t" className="rounded-2xl border border-dashed border-white/20 p-5 print:hidden" data-id="element-1031" data-mp="1ps0fxe8ecd40">
      <h2 id="pend-t" className="font-cinzel text-lg font-bold text-white" data-id="element-1032" data-mp="2ne7n8vw34jk2">
        Staff · Datos del Market por confirmar
      </h2>
      <p className="mt-1 text-sm text-gray-400" data-id="element-1033" data-mp="2ii93xmpm5rqi">Visible solo en la vista previa. La guía pública no muestra estos valores como vigentes.</p>
      <ul className="mt-4 divide-y divide-white/5" data-id="element-1034" data-mp="28quy6x72jvox">
        {configurable.map(c => <li key={c.label} className="py-2.5 text-sm" data-id="element-1035" data-mp="365gx569rpac6">
            <p className="font-semibold text-white" data-id="element-1036" data-mp="3671raus66r9i">
              {c.label}: <span className={c.value ? 'text-[#D4AF37]' : 'text-amber-300'} data-id="element-1037" data-mp="31eqpfmdvcveb">{c.value ?? 'sin confirmar'}</span>
            </p>
            <p className="text-gray-400" data-id="element-1038" data-mp="12b7k2u3aw6jv">{c.note}</p>
          </li>)}
      </ul>
      <h3 className="mt-5 font-semibold text-white" data-id="element-1039" data-mp="16azm0ny6veg9">Diferencias registradas</h3>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-gray-300" data-id="element-1040" data-mp="slo01l3uq6nf">
        {sourceNotes.map(n => <li key={n} data-id="element-1041" data-mp="xixp2znbwgaq">{n}</li>)}
      </ul>
      <p className="mt-4 text-xs text-gray-500" data-id="element-1042" data-mp="xhmmv49j7glq">Capturas integradas: {screenshots.length} ({screenshots.map(s => s.file).join(', ')}).</p>
    </section>;
}